// Detailed Product Information for Review Pages

export const productDetails = {
  lulutox: {
    name: "Lulutox Detox Tea",
    fullName: "Lulutox-Entgiftungstee (Lulutox Detox Tea)",
    category: "Detox-/Wellness-Tee (Teebeutel)",
    image: "/images/products/luludex.png",
    rating: 4.9,
    price: "€ 29,90",
    badge: "Testsieger 2026",
    
    description: "Eine Detox-Teemischung, die laut Anbieter das Wohlbefinden unterstützen und u. a. Blähungsgefühle beruhigen sowie die Stoffwechsel-/Energie-Routine ergänzen soll.",

	    // First-screen decision helper (mobile-friendly)
	    decision: {
	      quickTake: "Kurzfazit: Für alle, die eine ‚leichter fühlen‘-Routine mit mildem Koffein suchen – laut Anbieter mit Fokus auf Wohlbefinden, Bauch-Komfort und tägliche Energie.",
	      forWho: [
	        "Morgens/Tagsüber: wenn du einen sanften Energie-Boost im Alltag möchtest",
	        "Wenn du nach dem Essen eher zu Völlegefühl/Blähungen neigst und ein Tee-Ritual suchst",
	        "Wenn du Detox-/Abnehm-Routinen mit Zutaten wie Grüntee/Mate ergänzen willst"
	      ],
	      notForWho: [
	        "Wenn du sehr koffeinempfindlich bist oder abends empfindlich reagierst",
	        "Schwangerschaft/Stillzeit: vorher ärztlich abklären",
	        "Bei Medikamenten/Vorerkrankungen: zuerst Arzt/Apotheker fragen"
	      ]
	    },
    
    benefits: [
      "Unterstützung des Wohlbefindens",
      "Mehr Energie im Alltag",
      "Beruhigung von Blähungsgefühlen",
      "Ergänzung der Stoffwechsel-Routine"
    ],
    
    ingredients: [
      "Matcha-Grüntee",
      "Yerba Mate",
      "Oolong-Tee",
      "Sencha-Grüntee",
      "Löwenzahnblatt",
      "Ginseng",
      "Mariendistel",
      "Brennnesselblatt",
      "Zitronengras",
      "Goji-Beeren",
      "Zitronensäure",
      "Apfel",
      "Stevia"
    ],
    
    ingredientDetails: [
      {
        name: "Matcha",
        description: "Reich an Aminosäuren und Antioxidantien; wird oft im Kontext von Energie- und Stoffwechsel-Routinen genannt."
      },
      {
        name: "Mate",
        description: "Wird zur Energie und mentalen Klarheit beworben, ohne die typische Kaffee-Unruhe."
      },
      {
        name: "Grüner Tee Sencha",
        description: "Antioxidantien; häufig im Kontext von Zellschutz und allgemeinem Wohlbefinden erwähnt."
      },
      {
        name: "Oolong-Tee",
        description: "Wird als beruhigend beschrieben; reich an Mineralstoffen und Vitaminen."
      },
      {
        name: "Goji-Beeren",
        description: "Historisch mit Leistungssteigerung beworben; Eisenquelle."
      },
      {
        name: "Mariendistel",
        description: "Traditionell als Leber-Kraut bekannt; wird häufig zur Unterstützung der Leberfunktion beworben."
      },
      {
        name: "Ginseng",
        description: "Wird oft mit Stressresistenz und Leistungsfähigkeit in Verbindung gebracht; teils auch im Kontext von Immunsystem/Kreislauf erwähnt."
      },
      {
        name: "Zitronengras",
        description: "Traditionell im Kontext von Magen-Darm-Wohlbefinden verwendet; viele trinken es gerne nach dem Essen."
      },
      {
        name: "Brennnesselblätter",
        description: "Traditionell im Kontext von Entwässerung und Wohlbefinden genutzt; teils auch bei saisonalen Beschwerden erwähnt."
      },
      {
        name: "Löwenzahnblatt",
        description: "Als nährstoffreiches Grün beschrieben; wird häufig mit Verdauung/Entwässerung in Verbindung gebracht und ist beliebt in Detox- und Abnehm-Routinen."
      },
      {
        name: "Stevia-Blatt",
        description: "Als kalorienfreies, natürliches Süßungsmittel beschrieben."
      }
    ],
    
    taste: {
      profile: "Leichtes Pfirsich-Aroma (\"Smooth Peach Essence\")",
      notes: [
        "Laut FAQ: leichter Pfirsichgeschmack",
        "Auf der Produktseite wird der Geschmack in Kundenstimmen als sehr lecker/köstlich beschrieben"
      ]
    },
    
    caffeine: {
      contains: true,
      amount: "18mg pro Teebeutel",
      note: "Geringer Koffeingehalt im Vergleich zu vielen Grün-/Schwarztees"
    },
    
    properties: {
      vegan: true,
      glutenFree: true,
      dairyFree: true,
      soyFree: true,
      sugarFree: "Ohne Zuckerzusatz"
    },
    
    preparation: {
      hot: "Ca. 240 ml (8 oz) Wasser aufkochen, Teebeutel 4–6 Minuten ziehen lassen",
      cold: "Auch als Eistee möglich",
      frequency: "1–2 Tassen pro Tag"
    },
    
    packaging: "Pyramidenförmige Premium-Teebeutel, damit sich Geschmack und Zutaten vollständig entfalten können",
    
    guarantee: {
      days: 30,
      description: "30 Tage Geld-zurück-Garantie"
    },
    
    affiliateLink: "https://cdn.detoxteetest.com/7ZRZD2?utm_term={keyword}&gclid={gclid}&utm_creative={creative}&utm_campaign={campaignid}&offer=lulutox-de"
  },
  
  serenatox: {
    name: "Serenatox Detox Tea",
    fullName: "Serenatox Detox Tea",
    category: "Detox-/Kräutertee-Mischung (Teebeutel)",
    image: "/images/products/serenatox.png",
    rating: 4.8,
    price: "€ 24,90",
    badge: "Preistipp",
    
    description: "Serenatox wird als erfrischende Kräutertee-Mischung beschrieben, die dabei helfen soll, sich leichter und energiegeladener zu fühlen. Laut Anbieter passt der Tee in eine 24-Stunden-Routine (morgens Klarheit, nachmittags Balance, abends Ruhe).",

	    // First-screen decision helper (mobile-friendly)
	    decision: {
	      quickTake: "Kurzfazit: Preistipp mit kräuterig-zitrischem Profil – laut Anbieter als 24h-Routine positioniert (morgens klarer, abends ruhiger).",
	      forWho: [
	        "Wenn du einen frischen Kräutertee mit Zitrus-/Ingwer-Note magst",
	        "Wenn du als Zielgefühl ‚leichter & weniger aufgebläht‘ suchst (Erfahrungen variieren)",
	        "Wenn dir Preis/Leistung wichtig ist, aber du trotzdem eine Routine willst"
	      ],
	      notForWho: [
	        "Wenn du koffeinfrei brauchst (Grüntee/Mate enthalten meist Koffein)",
	        "Bei sehr empfindlichem Magen: Ingwer/Zitrus kann reizend wirken",
	        "Schwangerschaft/Stillzeit oder Vorerkrankungen: vorher abklären"
	      ]
	    },
    
    benefits: [
      "Unterstützung der Verdauung",
      "Hilfe beim Stress-Management (als beruhigendes Tee-Ritual beschrieben)",
      "Sanfter Energieschub (u. a. durch Grüntee, ohne 'Crash' als Claim)",
      "Allgemeines Gefühl von Balance/Erfrischung im Alltag",
      "Unterstützung bei Blähungen und des 'natürlichen Detox-Prozesses'"
    ],
    
    ingredients: [
      "Grüntee",
      "Brasilianischer Mate",
      "Zitronenschale",
      "Zitronengras",
      "Fenchel",
      "Goji-Beeren",
      "Ingwerstücke",
      "Brennnesselblätter",
      "Ananasflocken"
    ],

    ingredientDetails: [
      {
        name: "Grüntee",
        description: "Enthält natürliche Pflanzenstoffe (u. a. Catechine) und wird häufig als Teil von Energie- und Stoffwechsel-Routinen genannt."
      },
      {
        name: "Mate",
        description: "Beliebt für waches, fokussiertes Gefühl; wird oft als sanfter Koffein-Boost beschrieben."
      },
      {
        name: "Ingwer",
        description: "Wird traditionell im Kontext von Wärmegefühl und Bauch-Komfort verwendet."
      },
      {
        name: "Fenchel",
        description: "In der Kräutertradition häufig mit Völlegefühl und Verdauungs-Wohlbefinden verbunden."
      },
      {
        name: "Brennnessel",
        description: "Wird traditionell im Kontext von Entwässerung und 'Detox-Routine' erwähnt."
      }
    ],

    taste: {
      profile: "Kräuterig-zitrisch mit fruchtiger Note",
      notes: [
        "Auf Basis der Zutaten ist ein kräuterig-zitrisches Profil mit fruchtiger Note (Ananas) und leichter Schärfe (Ingwer) plausibel"
      ]
    },

    caffeine: {
      contains: true,
      amount: "Nicht angegeben",
      note: "Enthält voraussichtlich natürliches Koffein durch Grüntee und Mate"
    },

    properties: {
      vegan: true,
      gmoFree: true
    },

    preparation: {
      dosage: "1 Teebeutel pro Tasse",
      steepTime: "3-5 Minuten",
      hot: "Kann heiß oder als Eistee getrunken werden",
      frequency: "1-2 Tassen pro Tag; idealerweise morgens oder früher Nachmittag"
    },

    faq: {
      sideEffects: "Im Allgemeinen gut verträglich; möglich sind milde Verdauungsänderungen. Bei Unwohlsein absetzen und medizinischen Rat einholen.",
      medications: "Bei verschreibungspflichtigen Medikamenten oder Vorerkrankungen vorher mit Arzt/Apotheker abklären.",
      whenResults: "Viele berichten, sich innerhalb weniger Tage leichter und weniger aufgebläht zu fühlen; Ergebnisse variieren je nach Lebensstil."
    },

    safety: {
      adultsOnly: true,
      notUnder18: true,
      pregnancyNote: "Vorher ärztlich abklären",
      disclaimer: "Hinweis: Aussagen zum Wohlbefinden beruhen auf Herstellerangaben und Erfahrungsberichten und sind nicht als medizinische Heilversprechen zu verstehen."
    },

    shipping: {
      processingTime: "Versand/Abwicklung innerhalb von 24 Stunden nach Bestellung",
      deliveryTime: "Typischerweise 5-7 Werktage",
      returnPolicy: {
        days: 14,
        conditions: "Ungeöffnet, Originalzustand inkl. Verpackung/Zubehör, nicht beschädigt; Rückgabe vorher per E-Mail ankündigen",
        refundDays: 60,
        shippingCost: "Trägt der Kunde; nicht erstattungsfähig"
      }
    },

    affiliateLink: "https://cdn.detoxteetest.com/7ZRZD2?utm_term={keyword}&gclid={gclid}&utm_creative={creative}&utm_campaign={campaignid}&offer=serenatox-de"
  }
};

